import { AssignmentCommitmentStatus } from '../../models'

export const values = [
  { key: AssignmentCommitmentStatus.Mandatory, value: 'Required' },
  { key: AssignmentCommitmentStatus.Optional, value: 'Optional' },
  { key: AssignmentCommitmentStatus.None, value: 'Not Included' },
]
